import React, { useState, useEffect } from "react";
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Loader from "../../visualComponents/Loader.js";
import Tooltip from "../../components/Tooltip.js";

let isLoading = false;

const ResocontoPiano = ({ isVisible, infoCodice }) => {
    const navigate = useNavigate();

    const handleAnnulla = () => {
        const input = document.querySelector('input');
        input.removeAttribute('disabled');
        window.location.reload();
    };

    const handleConferma = async () => {
        try {
            isLoading = true;
            const response = await fetch('/aggiornaLicenzaDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ IDLicenza: infoCodice.ID, CodiceDominio: infoUtente.CodiceDominio }),
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                navigate('/dashManager');
            }
        } catch (error) {
            alert('Errore nella connessione al server');
            console.log(error);
            window.location.reload();
        }
    };

    if (!isVisible) return null;

    return (
        <div className="mt-1 text-center">
            <h2 className="mb-3">Revisione del piano</h2>
            <p className="mb-2">Nome: {infoCodice.Nome}</p>
            <p className="mb-2">Descrizione: {infoCodice.Descrizione}</p>
            <div className='mt-3 grid grid-cols-2'>
                <button
                    onClick={handleAnnulla}
                    className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                >
                    Annulla
                </button>
                <button
                    onClick={handleConferma}
                    className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                >
                    Conferma
                </button>
            </div>
        </div>
    );
};

const PopUp = ({ isVisible, setIsVisible }) => {
    const [infoCodiceAtt, setInfoCodiceAtt] = useState("");
    const [isResocontoVisible, setIsResocontoVisible] = useState(false);

    const checkCodice = async () => {
        try {
            isLoading = true;
            const response = await fetch('/checkCodiceAttivazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceAtt: infoCodiceAtt }),
            });

            const data = await response.json();

            if (response.status === 200) {
                isLoading = false;
                if (data[0].Obsoleto) {
                    alert('Licenza obsoleta');
                    return;
                };

                if (data[0].DataAttivazione !== null) {
                    alert('Licenza già utilizzata');
                    return;
                };

                setInfoCodiceAtt(data[0]);
                setIsResocontoVisible(true);
                const input = document.querySelector('input');
                input.setAttribute('disabled', 'true');
            }
            else {
                alert(data["error"]);
            }
        } catch (error) {
            alert('Errore nella connessione al server');
            console.log(error);
            window.location.reload();
        }
    };

    const closeModal = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Cambia Licenza</h2>
                    <Tooltip content="Chiudi" >
                        <button className="text-red-500" onClick={closeModal}>
                            <X size={24} />
                        </button>
                    </Tooltip>
                </div>
                <div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Codice di attivazione: </p>
                        <div className="relative flex items-center">
                            <input
                                type="text"
                                placeholder=""
                                value={infoCodiceAtt.CodiceAttivazione}
                                onChange={(e) => setInfoCodiceAtt(e.target.value)}
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 w-full"
                                onBlur={checkCodice}
                            />
                        </div>
                    </div>
                    <ResocontoPiano
                        isVisible={isResocontoVisible}
                        infoCodice={infoCodiceAtt}
                    />
                </div>
            </div>
        </div>
    );
};

const Licenza = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [licenza, setLicenza] = useState([]);
    const [piano, setPiano] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        try {
            isLoading = true;

            await loadNav();

            const r2 = await fetch("/getInfoLicenza", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                window.location.reload();
            } else {
                const r3 = await fetch("/getInfoPiano", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
                });

                const rd3 = await r3.json();

                if (r3.status === 500) {
                    alert(rd3.error);
                    console.log(rd3.error);
                    window.location.reload();
                } else {
                    isLoading = false;
                    setLicenza(rd2[0]);
                    setPiano(rd3[0]);
                }
            }
        } catch (error) {
            alert('Errore nel caricamento della pagina, riprovare più tardi');
            console.log(error)
            navigate('/dashManager');
        }
    };

    const handleNotifica = async () => {
        try {
            isLoading = true;
            const response = await fetch('/sendNotificaScadenza', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    Scadenza: licenza['DataScadenza'],
                    EmailManager: infoUtente["Email"]
                }),
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                alert('Notifica inviata con successo');
            }

        } catch (error) {
            alert('Errore nella connessione al server');
            console.log(error);
            window.location.reload();
        }
    };

    const handleCambia = () => {
        setIsVisible(true);
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"LICENZA"} />
            {isLoading && <Loader />}
            <div className="flex justify-center min-h-screen p-4">
                <div className="w-full max-w-lg text-center text-black dark:text-white mt-14">
                    <p className="mb-2">Codice licenza: {licenza['CodiceAttivazione']}</p>
                    <p className="mb-2">Nome del piano: {piano['Nome']}</p>
                    <p className="mb-2">Descrizione del piano: {piano['Descrizione']}</p>
                    <p className="mb-2">Data di attivazione: {licenza['DataAttivazione']}</p>
                    <p className="mb-2">Data di scadenza: {licenza['DataScadenza']}</p>
                    <div className='py-4 grid grid-cols-2'>
                        <button
                            onClick={handleNotifica}
                            className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2"
                        >
                            Notifica scandenza
                        </button>
                        <button
                            onClick={handleCambia}
                            className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2"
                        >
                            Cambia Licenza
                        </button>
                    </div>
                </div>
            </div>
            <PopUp isVisible={isVisible} setIsVisible={setIsVisible} />
        </div>
    );
};

export default Licenza;